// extracted by mini-css-extract-plugin
export default {"error":"DefaultErrorRenderer_error__SFWNg","spin":"DefaultErrorRenderer_spin__e4Dtx"};